import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './button.scss';

class Button extends Component {
  static propTypes = {
    audio: PropTypes.bool,
    borderWeight: PropTypes.string,
    secondary: PropTypes.bool,
    intro: PropTypes.bool,
    onClick: PropTypes.func,
    muted: PropTypes.bool,
    primary: PropTypes.bool,
    size: PropTypes.string,
    success: PropTypes.bool,
    link: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    facebook: PropTypes.bool,
    disabled: PropTypes.bool,
    round: PropTypes.bool,
  };

  static defaultProps = {
    audio: false,
    borderWeight: 'normal',
    secondary: false,
    intro: false,
    primary: false,
    muted: false,
    success: false,
    facebook: false,
    disabled: false,
    round: false,
  };

  onClick = () => {
    const { onClick } = this.props;

    if (onClick) {
      onClick();
    }
  };

  getClassNames () {
    const { className, audio, borderWeight, secondary, disabled, facebook, intro, muted, primary, round, size, success } = this.props;

    return classnames(className, {
      [styles.audio]: audio,
      [styles.button]: true,
      [styles.secondary]: secondary,
      [styles.disabled]: disabled,
      [styles.facebook]: facebook,
      [styles.intro]: intro,
      [styles.muted]: muted,
      [styles.primary]: primary,
      [styles.round]: round,
      [styles.success]: success,
      [styles[`size${size}`]]: size,
      [styles[`borderWeight--${borderWeight}`]]: borderWeight,
    })
  }

  render () {
    const { link, children } = this.props;
    const Element = link ? 'a' : 'button';

    return (
      <Element
        onClick={this.onClick}
        className={this.getClassNames()}
        href={link}
      >
        {children}
      </Element>
    )
  }
}

export { Button };



// WEBPACK FOOTER //
// ./src/elements/button/button.js